import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { MainCmsComponents } from '@core/const';
import { CmsConfig, ConfigModule, UrlModule } from '@spartacus/core';
import { GenericLinkComponent } from '@spartacus/storefront';
import { SitemapComponent } from './sitemap.component';

@NgModule({
  declarations: [SitemapComponent],
  imports: [
    NgFor,
    NgIf,
    AsyncPipe,
    ConfigModule.withConfig(<CmsConfig>{
      cmsComponents: {
        [MainCmsComponents.SdSitemapComponent]: {
          component: SitemapComponent,
        },
      },
    }),
    GenericLinkComponent,
    UrlModule,
  ],
})
export class SitemapModule {}
